import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ArticlesGrid } from '../components/ArticlesGrid';
import { MediaSection } from '../components/MediaSection';
import { ConsultingSection } from '../components/ConsultingSection';
import { TimelineSection } from '../components/TimelineSection';
import { WorkHistorySection } from '../components/WorkHistorySection';
import { ContactSection } from '../components/ContactSection';
export function HomePage() {
  // Enable smooth scrolling on the document level
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-[#0B1120] font-sans text-white" data-id="element-246">
      <Navigation data-id="element-247" />

      <main data-id="element-248">
        <HeroSection data-id="element-249" />
        <AboutSection data-id="element-250" />
        <ArticlesGrid data-id="element-251" />
        <MediaSection data-id="element-252" />
        <ConsultingSection data-id="element-253" />
        <TimelineSection data-id="element-254" />
        <WorkHistorySection data-id="element-255" />
      </main>

      <ContactSection data-id="element-256" />
    </div>;
}